/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type { PropertyAccount } from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary All accounts (current and ceased) ever held at a property
 */
export const getAccountsByProperty = (
  propertyId: number,
  options?: SecondParameter<typeof backofficeRequest<PropertyAccount[]>>,
) => {
  return backofficeRequest<PropertyAccount[]>(
    { url: `/properties/${propertyId}/accounts`, method: "GET" },
    options,
  )
}
export type GetAccountsByPropertyResult = NonNullable<
  Awaited<ReturnType<typeof getAccountsByProperty>>
>
